var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUploadCadastro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.452,
    height: 24.29,
    viewBox: "0 0 19.452 24.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-upload-cadastro",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M13.051.18a.563.563,0,0,0-.4-.18H3.56A3.073,3.073,0,0,0,.5,3.055V20.235A3.073,3.073,0,0,0,3.56,23.29H15.892a3.073,3.073,0,0,0,3.06-3.055V6.593a.606.606,0,0,0-.163-.394Zm.163,1.806,3.842,4.034h-2.5a1.34,1.34,0,0,1-1.345-1.339Zm2.678,20.179H3.56a1.949,1.949,0,0,1-1.935-1.93V3.055A1.949,1.949,0,0,1,3.56,1.125h8.528V4.681a2.461,2.461,0,0,0,2.47,2.464h3.268V20.235A1.945,1.945,0,0,1,15.892,22.165Zm0,0",
    transform: "translate(-0.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M98.994,401.934h-9.26a.563.563,0,0,0,0,1.125H99a.563.563,0,1,0-.006-1.125Zm0,0",
    transform: "translate(-85.138 -384.969)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M119.365,174.781l2.318-2.492v4.825a.563.563,0,0,0,1.125,0v-4.825l2.318,2.492a.561.561,0,0,0,.821-.765l-3.3-3.539a.558.558,0,0,0-.821,0l-3.3,3.539a.561.561,0,0,0,.028.793A.574.574,0,0,0,119.365,174.781Zm0,0",
    transform: "translate(-113.02 -162.551)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUploadCadastro);
export default __webpack_public_path__ + "static/media/ico-upload-cadastro.4a7948b8c9cb0ce5d9f1e8312e63802a.svg";
export { ForwardRef as ReactComponent };